module.exports = __webpack_public_path__ + "img/wholechain.92857638.svg";